import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
// import logo from '../assets/img/logo.svg';
// import logo from '../assets/img/style4FaceSmall.webp';
import logo from '../assets/img/logo lc-square-colored-light.png';
import logoDark from '../assets/img/logo-lc-3-space-large.png';
import { useMediaQuery } from 'react-responsive';
import { Link } from "react-router-dom";

export const NavBar = ({ theme, toggleTheme }) => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [isNavBarCollapsed, setIsNavBarCollapsed] = useState(true);

  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const handleNavBarCollapsed = () => {
    const navbarCollapse = document.getElementById('basic-navbar-nav');
    if (!navbarCollapse) return;

    if (navbarCollapse.classList.contains('show')) {
      setIsNavBarCollapsed(true);
    } else {
      setIsNavBarCollapsed(false);
    }
  }

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
    setAnimationClass("popup");
    window.scrollTo(0, 0);

    setTimeout(() => setAnimationClass(""), 300);
  }

  return (
    <Navbar expand="md" className={scrolled ? "" : ""} style={isMobile ? (isNavBarCollapsed ? { padding: ".8rem 0" } : { padding: "0", paddingTop: ".8rem" }) : undefined}>
      {/* <Navbar expand="md" className="scrolled"> */}
      {/* <Container className={useFull ? "full-width" : "low-width"}> */}
      <Container className={"width-base"} style={{ height: "100%" }}>

        <Link to="/" onClick={() => window.scrollTo(0, 0)}
          className="navbar-brand"
          style={{ cursor: 'pointer' }}
        >
          {/* {scrolled ? (
              <p className="animate__animated animate__fadeIn animate__faster">LC<span style={{ color: "#fcc244" }}>.</span></p>
            ) : (
              <img id='logo-img' src={logo} alt="Logo" className="animate__animated animate__fadeIn animate__faster" />
            )} */}
          {theme === 'light' ? <img id='logo-img' src={logo} alt="Logo" /> : <img id='logo-img' src={logoDark} alt="Logo" />}
          {/* <p>LC<span style={{ color: "var(--color-accent)" }}>.</span></p> */}
          {/* <img id='logo-img' src={logo} alt="Logo" className="animate__animated animate__fadeIn animate__faster" /> */}
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className={isMobile ? "navbar-controls-mobile" : ""}
          onClick={handleNavBarCollapsed}>
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav" className={isMobile ? "navbar-collapse-mobile" : ""}>
          {/* <Nav id="navbar-content" className={scrolled ? "navbar-cont-justify-right" : "navbar-cont-justify-center"}> */}
          <Nav id="navbar-content" className="ms-auto">

            <Nav.Link href="/about" className={`${activeLink === 'about' ? 'active navbar-link' : 'navbar-link'}
                  ${activeLink === 'about' ? animationClass : ''} ${isMobile ? "nav-link-mobile" : ""}`} onClick={() => onUpdateActiveLink('about')}>
              <p>About me</p>
            </Nav.Link>

            <Nav.Link href="/projects" className={`${activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'}
                  ${activeLink === 'projects' ? animationClass : ''} ${isMobile ? "nav-link-mobile" : ""}`} onClick={() => onUpdateActiveLink('projects')}>
              <p>Projects</p>
            </Nav.Link>

            {/* <Nav.Link href="#experiences" className={activeLink === 'experiences' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('experiences')}>Experiences</Nav.Link>
              <Nav.Link href="#education" className={activeLink === 'education' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('education')}>Education</Nav.Link> */}

            {/* <Nav.Link href="/blog" className={`${activeLink === 'blog' ? 'active navbar-link' : 'navbar-link'}
                  ${activeLink === 'blog' ? animationClass : ''}`} onClick={() => onUpdateActiveLink('blog')}>
              <p>Blog</p>
            </Nav.Link> */}

            <Nav.Link href="/contact" className={`${activeLink === 'contact' ? 'active navbar-link' : 'navbar-link'}
                  ${activeLink === 'contact' ? animationClass : ''} ${isMobile ? "nav-link-mobile" : ""}`} onClick={() => onUpdateActiveLink('contact')}>
              <p>Contact</p>
            </Nav.Link>

            {/* <Nav.Link as="button" className={`${'navbar-link'} ${activeLink === 'mode' ? animationClass : ''} ${isMobile ? "nav-link-mobile" : ""}`}
              onClick={() => { onUpdateActiveLink('mode'); toggleTheme(); }}>
              {isMobile ? (theme === 'light' ? <p>Dark Mode</p> : <p>Light Mode</p>) : (theme === 'light' ? <DarkMode /> : <LightMode />)}
            </Nav.Link> */}

          </Nav>
          {/* <span className="navbar-text">
              <div className="social-icon">
                <a href="#"><img src={navIcon1} alt="" /></a>
                <a href="#"><img src={navIcon2} alt="" /></a>
                <a href="#"><img src={navIcon3} alt="" /></a>
              </div>
              <HashLink to='#connect'>
            */}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
